import { render, staticRenderFns } from "./sistema-formato-unico-shcp.vue?vue&type=template&id=14b4414e&scoped=true"
import script from "./sistema-formato-unico-shcp.vue?vue&type=script&lang=js"
export * from "./sistema-formato-unico-shcp.vue?vue&type=script&lang=js"
import style0 from "./sistema-formato-unico-shcp.vue?vue&type=style&index=0&id=14b4414e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b4414e",
  null
  
)

export default component.exports